__turbopack_context__.v({
  "className": "cormorant_garamond_ba88d260-module__Z66nTa__className",
});
